export default __webpack_public_path__ + "static/media/cancelIcon.5f10d053.svg";